import getDOMfromString from '../../../helpers/getDOMfromString';
import './styles.css';

/**
 * Generates home icon/button
 *
 * @param {Object} config - options for btn
 * @returns {HTMLElement|string} - button/button string
 */
const createFilterNavigation = config => {
    const {navClasses = '', prevBtnClasses = '', nextBtnClasses = '', forceShow = false, labels = {}} = config ?? {};

    const htmlStr = `<div class="filter-btns-nav ${navClasses}">
    <button type="button" class="filter-btn-prev filter-nav ${
        forceShow ? '' : 'swiper-button-lock'
    } ${prevBtnClasses}" aria-label="${labels.previous}" title="${labels.previous}">
        <svg aria-hidden="true" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.75 15.5L14.75 10.5L9.75 5.5L8.6875 6.5625L12.625 10.5L8.6875 14.4375L9.75 15.5Z" fill="white"/>
        </svg>
    </button>
    <button type="button" class="filter-btn-next filter-nav ${
        forceShow ? '' : 'swiper-button-lock'
    } ${nextBtnClasses}" aria-label="${labels.next}" title="${labels.next}">
        <svg aria-hidden="true" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.75 15.5L14.75 10.5L9.75 5.5L8.6875 6.5625L12.625 10.5L8.6875 14.4375L9.75 15.5Z" fill="white"/>
        </svg>
    </button>
</div>`;

    return getDOMfromString(htmlStr);
};

export default createFilterNavigation;
